import {Dimensions, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  content: {
    flex: 1,
    backgroundColor: white,
  },
  contentLoading: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: white,
  },
  sections: {
    paddingBottom: 60,
  },
  taskDetailsTitle: {
    fontSize: 16,
    marginTop: indent * 0.1,
    alignSelf: 'flex-start',
  },
  tabLayout: {
    width: Dimensions.get('window').width - 38,
    alignSelf: 'center',
    flex: 0,
    marginHorizontal: 20,
  },
});
